/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
import { getDomainName, langFallback$Fetch } from '~/lang/utils/langfetch'

export async function submitEmailLogin(
  {
    email,
    password,
  }: {
    email: string
    password: string
  },
  { langCode }: { langCode: string },
) {
  try {
    // TODO: Add proper response type from API schema

    const response: any = await langFallback$Fetch(
      langCode,
      `/email-jwt?domain=${getDomainName()}`,
      {
        method: 'POST',
        mode: 'cors',
        credentials: 'same-origin',
        body: JSON.stringify({ email, password }),
      },
    )

    return response.token
      ? { isManager: response.is_manager }
      : { message: response.error.__all__[0] }
  } catch (e) {
    const error = e as any
    // Handle the new email verification error format

    if (error.data && error.data.error === 'email_not_verified') {
      // eslint-disable-next-line no-throw-literal
      throw {
        message: error.data.message,
      }
    }

    const extractFormError = (response: any): string | null => {
      const errors = response?.data?.errors || response?._data?.errors
      return errors?.__all__?.[0] || null
    }

    const formError = extractFormError(error.response)
    if (formError) {
      // eslint-disable-next-line no-throw-literal
      throw {
        message: formError,
        formError: formError,
      }
    }

    // Only use generic fallback if no server message available
    // eslint-disable-next-line no-throw-literal
    throw { message: 'Login failed' }
  }
}
